import { useEffect } from "react";
import { Link } from "react-router-dom";
import useScrollAnimation from "../../hooks/useScrollAnimation";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import SERVICES_DATA from "../services/data";

const HizmetlerPage = () => {
  useScrollAnimation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-[#0D0D0D] overflow-hidden">
        <div className="absolute inset-0 opacity-15">
          <img
            src="/images/menu-icin-cephe-44a1019c.png"
            alt="Hizmetler"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute top-0 left-0 w-1.5 h-full bg-[#E6A800]" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-2 mb-6 anim-down d0">
            <Link to="/" className="text-white/40 text-xs font-head hover:text-[#E6A800] tr uppercase tracking-wider">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line text-white/30 text-xs" />
            <span className="text-[#E6A800] text-xs font-head uppercase tracking-wider">Hizmetler</span>
          </div>
          <div className="flex items-center gap-3 mb-5 anim-left d1">
            <div className="w-8 h-[2px] bg-[#E6A800]" />
            <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">Uzmanlık Alanlarımız</span>
          </div>
          <h1 className="font-head font-black uppercase text-white text-[clamp(48px,8vw,100px)] leading-[0.88] anim-up d2">
            Hizmet
            <br />
            <span className="text-[#E6A800]">Kategorileri</span>
          </h1>
          <p className="text-white/50 text-sm leading-relaxed max-w-lg mt-6 anim-up d3">
            Tasarımdan üretime, montajdan bakıma kadar tüm süreçleri kendi bünyemizde
            yönetiyoruz. Osmaniye ve çevresinde 20 yılı aşkın deneyimle hizmetinizdeyiz.
          </p>
        </div>
      </section>

      {/* Stats strip */}
      <div className="bg-[#E6A800]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex flex-wrap justify-center sm:justify-between divide-x divide-white/20">
            {[
              { value: "1.620+", label: "Proje" },
              { value: "300+", label: "Mutlu Marka" },
              { value: "20+", label: "Yıllık Tecrübe" },
              { value: "18", label: "Şehirde Aktif" },
            ].map((s) => (
              <div key={s.label} className="flex flex-col items-center px-8 py-5 flex-1">
                <span className="font-head font-black text-white text-2xl leading-none">{s.value}</span>
                <span className="text-white/70 text-[10px] font-head uppercase tracking-wider mt-1">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Services Grid */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {SERVICES_DATA.map((svc, i) => (
              <Link
                key={svc.slug}
                to={`/hizmetler/${svc.slug}`}
                className="group flex flex-col overflow-hidden border border-[#E8E8E8] hover:border-[#E6A800] tr cursor-pointer anim-up"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                {/* Image */}
                <div className="relative h-[200px] overflow-hidden bg-[#F7F7F7]">
                  <img
                    src={svc.heroImg}
                    alt={svc.title}
                    className="w-full h-full object-cover object-center tr group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-[#0D0D0D]/40 tr group-hover:bg-[#0D0D0D]/20" />
                  <div className="absolute top-3 left-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#E6A800]">
                      <i className={`${svc.icon} text-white text-sm`} />
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 h-[3px] bg-[#E6A800] w-0 group-hover:w-full tr" />
                </div>
                {/* Content */}
                <div className="flex flex-col flex-1 p-5 bg-white">
                  <h3 className="font-head font-black uppercase text-[#0D0D0D] text-lg leading-tight mb-2 group-hover:text-[#E6A800] tr">
                    {svc.title}
                  </h3>
                  <p className="text-[#737373] text-xs leading-relaxed flex-1 mb-4">
                    {svc.description}
                  </p>
                  <div className="flex items-center gap-2 text-[#E6A800] font-head font-700 uppercase text-xs tracking-wider group-hover:gap-3 tr">
                    Detayları Gör
                    <i className="ri-arrow-right-line text-sm" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-[#181614]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="anim-left">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-8 h-[3px] bg-[#E6A800]" />
                <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">Ücretsiz Keşif</span>
              </div>
              <h2 className="font-head font-black uppercase text-white text-4xl md:text-5xl leading-[0.9] mb-6">
                Projeniz İçin
                <br />
                <span className="text-[#E6A800]">Teklif Alın</span>
              </h2>
              <p className="text-white/60 text-sm leading-relaxed max-w-md mb-8">
                Osmaniye ve çevresinde ücretsiz keşif yapıyoruz. 24 saat içinde
                detaylı teklif hazırlıyoruz. Hemen arayın, hemen çözüm!
              </p>
              <div className="flex flex-wrap gap-4">
                <a
                  href="tel:+905511830918"
                  className="inline-flex items-center gap-3 px-7 py-4 bg-[#E6A800] text-white hover:bg-[#C99500] tr font-head font-700 uppercase tracking-wider text-sm cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-phone-fill text-sm" />
                  +90 551 183 09 18
                </a>
                <a
                  href="https://wa.me/905511830918"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-3 px-7 py-4 bg-[#25D366]/15 border border-[#25D366]/30 text-[#25D366] font-head font-700 uppercase tracking-wider text-sm cursor-pointer whitespace-nowrap hover:bg-[#25D366]/25 tr"
                >
                  <i className="ri-whatsapp-line text-sm" />
                  WhatsApp
                </a>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4 anim-right d2">
              {[
                { icon: "ri-map-pin-user-line", title: "Ücretsiz Keşif", desc: "Osmaniye ve çevresinde ücretsiz ölçüm ve keşif" },
                { icon: "ri-draft-line", title: "Hızlı Teklif", desc: "24 saat içinde detaylı fiyat teklifi" },
                { icon: "ri-medal-line", title: "Kalite Garantisi", desc: "Malzeme ve işçilikte garanti belgesi" },
                { icon: "ri-time-line", title: "Zamanında Teslim", desc: "Söz verilen sürede tamamlama garantisi" },
              ].map((f) => (
                <div key={f.title} className="bg-white/5 border border-white/10 p-5 hover:border-[#E6A800]/50 tr">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#E6A800]/15 mb-3">
                    <i className={`${f.icon} text-[#E6A800] text-sm`} />
                  </div>
                  <h4 className="font-head font-700 uppercase text-white text-xs tracking-wide mb-1">{f.title}</h4>
                  <p className="text-white/40 text-xs leading-snug">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HizmetlerPage;
